import { SVGProps } from "react";

const MenuIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.3438 10.3372H5.65625C4.85938 10.3372 4.25 9.72781 4.25 8.93094C4.25 8.13406 4.85938 7.52469 5.65625 7.52469H25.3438C26.1406 7.52469 26.75 8.13406 26.75 8.93094C26.75 9.72781 26.1406 10.3372 25.3438 10.3372Z"
        fill="black"
      />
      <path
        d="M25.3438 16.8997H5.65625C4.85938 16.8997 4.25 16.2903 4.25 15.4934C4.25 14.6966 4.85938 14.0872 5.65625 14.0872H25.3438C26.1406 14.0872 26.75 14.6966 26.75 15.4934C26.75 16.2903 26.1406 16.8997 25.3438 16.8997Z"
        fill="black"
      />
      <path
        d="M25.3438 23.4622H5.65625C4.85938 23.4622 4.25 22.8528 4.25 22.0559C4.25 21.2591 4.85938 20.6497 5.65625 20.6497H25.3438C26.1406 20.6497 26.75 21.2591 26.75 22.0559C26.75 22.8528 26.1406 23.4622 25.3438 23.4622Z"
        fill="black"
      />
    </svg>
  );
};

export default MenuIcon;
